
import googlePlayImg from '@assets/images/element/google-play.svg';
import appStoreImg from '@assets/images/element/app-store.svg';
import { footerFeatures } from "../../../../_mock-api's/index";

const HomeFooter = () => {
  return (
    <section className="bg-light">
      <div className="container">
        <div className="row g-xl-4 g-3 align-items-center justify-content-center padding-mobile">
          {footerFeatures?.map((feature, index) => (
            <div key={index} className="col-lg-5 col-md-6 col-xl-4">
              <div className="bg-body d-flex rounded-3 h-100 p-4">
                <h3>
                  <i className={`fa-solid fa-${feature.icon}`}></i>
                </h3>
                <div className="ms-3">
                  <h5>{feature.title}</h5>
                  <p className="mb-0">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
          <div className="col-lg-5 col-xl-4">
            <div className="row g-xl-4 g-sm-3 g-2 justify-content-center">
              <div className="col-4 col-md-3 col-lg-6">
                <a
                  href={import.meta.env.VITE_GOOGLE_PAY_REDIRECT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-icon d-block px-md-0 px-1"
                >
                  <img src={googlePlayImg} alt="Google Play" />
                </a>
              </div>
              <div className="col-4 col-md-3 col-lg-6">
                <a
                  href={import.meta.env.VITE_APPLE_PAY_REDIRECT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-icon d-block px-md-0 px-1"
                >
                  <img src={appStoreImg} alt="App Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { HomeFooter };
